var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.83611 0 0 7.83611 0 17.5C0 27.1639 7.83611 35 17.5 35C19.1139 35 20.4167 33.6972 20.4167 32.0833C20.4167 31.325 20.1347 30.6444 19.6583 30.1292C19.2014 29.6139 18.9292 28.9431 18.9292 28.1944C18.9292 26.5806 20.2319 25.2778 21.8458 25.2778H25.2778C30.6444 25.2778 35 20.9222 35 15.5556C35 6.96111 27.1639 0 17.5 0ZM6.80556 17.5C5.19167 17.5 3.88889 16.1972 3.88889 14.5833C3.88889 12.9694 5.19167 11.6667 6.80556 11.6667C8.41944 11.6667 9.72222 12.9694 9.72222 14.5833C9.72222 16.1972 8.41944 17.5 6.80556 17.5ZM12.6389 9.72222C11.025 9.72222 9.72222 8.41944 9.72222 6.80556C9.72222 5.19167 11.025 3.88889 12.6389 3.88889C14.2528 3.88889 15.5556 5.19167 15.5556 6.80556C15.5556 8.41944 14.2528 9.72222 12.6389 9.72222ZM22.3611 9.72222C20.7472 9.72222 19.4444 8.41944 19.4444 6.80556C19.4444 5.19167 20.7472 3.88889 22.3611 3.88889C23.975 3.88889 25.2778 5.19167 25.2778 6.80556C25.2778 8.41944 23.975 9.72222 22.3611 9.72222ZM28.1944 17.5C26.5806 17.5 25.2778 16.1972 25.2778 14.5833C25.2778 12.9694 26.5806 11.6667 28.1944 11.6667C29.8083 11.6667 31.1111 12.9694 31.1111 14.5833C31.1111 16.1972 29.8083 17.5 28.1944 17.5Z",
    fill: "url(#paint0_linear_2100_9504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2100_9504",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ECBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.5b3194ea1b360468a8cb789b8d942359.svg";
export { ForwardRef as ReactComponent };